(function () {
  var DRAG_CLICK_THRESHOLD = 5;

  function removeStaleHarvestClones(scroller) {
    var track = scroller.querySelector('[data-fw-produce-harvest-track]');
    if (!track) return;
    track.querySelectorAll('[data-fw-harvest-clone]').forEach(function (node) {
      node.remove();
    });
  }

  function clampHarvestScroll(scroller) {
    var max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    if (scroller.scrollLeft > max) scroller.scrollLeft = max;
    if (scroller.scrollLeft < 0) scroller.scrollLeft = 0;
  }

  function initDragScroll(scroller) {
    if (scroller.dataset.fwProduceDragBound === 'true') return;
    scroller.dataset.fwProduceDragBound = 'true';

    removeStaleHarvestClones(scroller);
    clampHarvestScroll(scroller);
    scroller.addEventListener(
      'scroll',
      function () {
        clampHarvestScroll(scroller);
      },
      { passive: true }
    );

    scroller.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
    });

    var dragging = false;
    var startX = 0;
    var startScrollLeft = 0;
    var maxMoved = 0;
    var activePointerId = null;
    var suppressClick = false;

    scroller.addEventListener(
      'dragstart',
      function (event) {
        if (event.target && event.target.tagName === 'IMG') {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    scroller.addEventListener(
      'click',
      function (event) {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    scroller.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      dragging = true;
      maxMoved = 0;
      startX = event.clientX;
      startScrollLeft = scroller.scrollLeft;
      activePointerId = event.pointerId;
      suppressClick = false;

      scroller.classList.add('is-dragging');
      if (scroller.setPointerCapture) {
        scroller.setPointerCapture(event.pointerId);
      }
    });

    scroller.addEventListener('pointermove', function (event) {
      if (!dragging || event.pointerId !== activePointerId) return;

      var dx = event.clientX - startX;
      var moved = Math.abs(dx);
      if (moved > maxMoved) maxMoved = moved;

      scroller.scrollLeft = startScrollLeft - dx;
    });

    function endDrag(event) {
      if (!dragging || event.pointerId !== activePointerId) return;

      dragging = false;
      scroller.classList.remove('is-dragging');

      if (scroller.releasePointerCapture) {
        try {
          scroller.releasePointerCapture(activePointerId);
        } catch (err) {
          /* pointer already released */
        }
      }

      if (maxMoved > DRAG_CLICK_THRESHOLD) {
        suppressClick = true;
        window.setTimeout(function () {
          suppressClick = false;
        }, 0);
      }

      activePointerId = null;
      clampHarvestScroll(scroller);
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('lostpointercapture', function () {
      dragging = false;
      scroller.classList.remove('is-dragging');
      activePointerId = null;
    });
  }

  function initHarvestRoots() {
    document.querySelectorAll('[data-fw-produce-harvest] [data-fw-produce-scroller]').forEach(initDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHarvestRoots);
  } else {
    initHarvestRoots();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-fw-produce-harvest] [data-fw-produce-scroller]').forEach(function (scroller) {
      scroller.dataset.fwProduceDragBound = 'false';
      initDragScroll(scroller);
    });
  });
})();
